import { render } from "./Main.vue?vue&type=template&id=28b5ceaf"
import script from "./Main.vue?vue&type=script&setup=true&lang=js"
export * from "./Main.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/DirectMail/Main.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28b5ceaf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28b5ceaf', __exports__)) {
    api.reload('28b5ceaf', __exports__)
  }
  
  module.hot.accept("./Main.vue?vue&type=template&id=28b5ceaf", () => {
    api.rerender('28b5ceaf', render)
  })

}


export default __exports__